import React from "react";
import { Link } from "react-router-dom";
import { mainNavigation } from "../../config/navigation";
import MegaMenuServices from "./MegaMenu2";
import MegaMenuProducts from "./MegaMenuProducts";

interface HeaderNavMenuProps {
  onLinkClick?: () => void;
}

const HeaderNavMenu: React.FC<HeaderNavMenuProps> = ({ onLinkClick }) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    onLinkClick?.();
  };

  const renderMegaMenu = (type: "services" | "products") => {
    if (type === "services") return <MegaMenuServices />;
    return <MegaMenuProducts />;
  };

  return (
    <ul>
      {mainNavigation.map((item) => (
        <li
          key={item.id}
          className={
            item.megaMenu
              ? "menu-item-has-children megamenu"
              : item.link === "/"
                ? "active"
                : ""
          }
        >
          <Link to={item.link} onClick={handleClick}>
            <span>{item.title}</span>
          </Link>
          {item.megaMenu && renderMegaMenu(item.megaMenu)}
        </li>
      ))}
    </ul>
  );
};

export default HeaderNavMenu;
